import { useTranslation } from 'react-i18next';
import { ChangelogFilterByEnum, type ChangelogFilterByValue } from 'src/types';
import { changelogTagVariants } from '.';
import { cn } from 'src/utils';

type Props = {
  handleUpdateFilterBy: (clickedFilter: ChangelogFilterByValue) => void;
  handleUpdateVersionFilter?: (clickedVersion: string) => void;
  filterBy: ChangelogFilterByValue[];
  versionFilter?: string[];
  versions?: string[];
  showAllTag: boolean;
};

export const ChangelogFilterItems = ({
  handleUpdateFilterBy,
  handleUpdateVersionFilter,
  filterBy,
  versionFilter = [],
  versions = [],
  showAllTag,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      {Object.keys(ChangelogFilterByEnum).map((filter, i) => {
        if (!showAllTag && filter === 'all') {
          return null;
        }

        return (
          <li
            key={`filter-${i}`}
            id={filter}
            onClick={(e) => {
              e.stopPropagation();
              handleUpdateFilterBy(
                filter as keyof typeof ChangelogFilterByEnum,
              );
            }}
            className='group flex w-full cursor-pointer list-none flex-row items-center justify-start gap-4 whitespace-nowrap border-blueGray transition-all first:border-b first:pb-0.5'
          >
            <input
              readOnly
              type='checkbox'
              checked={filterBy.includes(
                filter as keyof typeof ChangelogFilterByEnum,
              )}
              className='green-checkbox bg-[#CFCFD0]'
            />
            <span
              className={cn(
                changelogTagVariants({
                  variant: filter as keyof typeof ChangelogFilterByEnum,
                }),
              )}
            >
              {t(`changelog.tags.${filter}`)}
            </span>
          </li>
        );
      })}
      {versions.length > 0 && handleUpdateVersionFilter && (
        <>
          <li className='mt-2 list-none w-full border-t border-blueGray pt-2 text-sm text-primary-dark'>
            {t('changelog.tags.version')}
          </li>
          {versions.map((version) => (
            <li
              key={`version-${version}`}
              className='list-none w-full'
            >
              <label
                htmlFor={`changelog-version-${version}`}
                className='group flex w-full cursor-pointer flex-row items-center justify-start gap-4 whitespace-nowrap border-blueGray transition-all'
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  id={`changelog-version-${version}`}
                  type='checkbox'
                  checked={versionFilter.includes(version)}
                  onChange={() => handleUpdateVersionFilter(version)}
                  className='green-checkbox bg-[#CFCFD0]'
                />
                <span
                  className={cn(
                    changelogTagVariants({
                      variant: 'version',
                    }),
                  )}
                >
                  {version}
                </span>
              </label>
            </li>
          ))}
        </>
      )}
    </>
  );
};
